var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoShieldXcover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    "aria-labelledby": titleId,
    role: "img",
    className: "xcover-shield",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M27.188 4.592 15-.004 2.812 4.592v11.991c0 2.003.877 3.84 1.956 5.367 1.091 1.543 2.508 2.935 3.863 4.084a39.344 39.344 0 0 0 5.307 3.768l.098.057.028.016.008.004.004.002.924.523.923-.522L15 28.25c.923 1.632.925 1.631.925 1.63h.003l.008-.005.028-.016.098-.057.353-.21c.3-.182.723-.446 1.23-.78a39.335 39.335 0 0 0 3.724-2.778c1.355-1.15 2.771-2.54 3.863-4.084 1.08-1.527 1.956-3.364 1.956-5.367V4.592ZM15 28.25l-.924 1.631L15 28.25ZM6.562 16.583V7.186L15 4.004l8.438 3.182v9.397c0 .915-.413 1.994-1.268 3.202-.842 1.19-2.003 2.351-3.227 3.39A35.595 35.595 0 0 1 15 26.056a35.595 35.595 0 0 1-3.943-2.882c-1.224-1.039-2.385-2.2-3.227-3.39-.855-1.208-1.268-2.287-1.268-3.202Zm14.66-4.504a1.875 1.875 0 0 0-3.068-2.157l-4.478 6.368-2.192-1.754a1.875 1.875 0 1 0-2.343 2.928l3.75 3a1.875 1.875 0 0 0 2.705-.385l5.625-8Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShieldXcover);
export default __webpack_public_path__ + "static/media/logo-shield-xcover.70863dfc3a442b5f92af27144a29f5c2.svg";
export { ForwardRef as ReactComponent };